import { Card } from "@blueprintjs/core";
import { ColorResult, SketchPicker } from 'react-color';

import { registerField, registerWidget } from "common/form/register";
import CssUnitWidget from "common/form/widgets/CssUnitWidget";
import PropertyReferencePicker from "core/components/editor/properties/PropertyReferencePicker";
import { PropertyType } from "core/decorators/PropertyType";
import ColorUtil from "core/util/ColorUtil";
import StringUtil from "core/util/StringUtil";
import { IFieldProps } from "decorator-form";
import React from "react";
import { AbstractPropertyType, PreviewDisplay } from "../../core/util/property/AbstractPropertyType";
import IPropertyRecord from "../../core/util/property/IPropertyRecord";
import ColorPickerWidget from "../form/widgets/ColorPickerWidget";
import { CssPropertyProvider, ICssProperty } from "./CssPropertyProvider";

interface ITextBlock {
	font: string;
	fontSize: string;
}

@PropertyType({name: "textBlock", label: "Typography"})
export default class TypographyPropertyType extends AbstractPropertyType<ITextBlock, ICssProperty[]> {

	public getDefaultValue() {
		return {
			font: "sans-serif",
			fontSize: "14px",
		};
	}

	public getValue(textBlock: ITextBlock): ICssProperty[] {
		return [
			{
				property: "fontFamily",
				value: textBlock.font
			},
			{
				property: "fontSize",
				value: textBlock.fontSize
			}
		];
	}

	public getInput(value: ITextBlock, onChange: (value: ITextBlock) => void,  wrapper?: IPropertyRecord<ITextBlock>) {
		return (
			<React.Fragment>
				<input type="text" value={value.font} onChange={(e) => {
					onChange({...value, font: e.target.value});
				}} />
				<CssUnitWidget value={value.fontSize} onChange={(v) => {
					onChange({...value, fontSize: v});
				}} />
			</React.Fragment>
		);
	}

	public getPreviewElement(value: ITextBlock, minimal: boolean, wrapper: IPropertyRecord<ITextBlock>) {
		return (
			<Card style={{
				padding: "5px"
			}}>
				<span style={CssPropertyProvider.fromProperties(...this.getValue(value))}>
					{wrapper.displayName}
				</span>
			</Card>
		);
	}
}



// WEBPACK FOOTER //
// ./src/common/theme/TypographyProperty.type.tsx